import React from 'react';
import styles from './map-wrapper.module.scss';

interface MapWrapperProps {
    panelWidth: number;
    containerId: string;
    children?: React.ReactNode;
    legend?: React.ReactNode;
    leftPanelOpened: boolean;
}

export function MapWrapper({ panelWidth, containerId, children, legend, leftPanelOpened }: MapWrapperProps) {

    const containerStyle = leftPanelOpened
        ? {
            transform: document.documentElement.dir === 'rtl' 
              ? `translateX(-${panelWidth}px)`
              : `translateX(${panelWidth}px)`,
            width: `calc(100% - ${panelWidth}px)`
        }
        : {};

    return (
        <div className={styles.map}>
            <div
                style={containerStyle}
                className={styles.mapContainer}
                id={containerId}
            >
                {children}
                {legend && legend}
            </div>
        </div>
    );
}
